export default __webpack_public_path__ + "static/media/landing_page_ausmeat.14845619.png";